import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';
import AOS from 'aos';
import 'aos/dist/aos.css';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;
      transform: translate(-4px, -4px);

      &:after {
        transform: translate(8px, 8px);
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 14px;
      left: 14px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    AOS.init();
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = ['Amazon Web Services (AWS)',
            'Google Cloud Platform (GCP)',
            'Microsoft Azure',
            'Kubernetes',
            'Docker',
            'Linux',
            'Azure DevOps',
            'ArgoCD',
            'Helm',
            'Jenkins',
            'Terraform',
            'AWS CDK',
            'Ansible',
            'Python',
            "New Relic",
            "Prometheus",
            "Grafana",
            "Dynatrace",
            "Jira",
            "Confluence"
          ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading" data-aos="fade-up">About Me</h2>

      <div className="inner"  data-aos="fade-up">
        <StyledText data-aos="fade-up">
          <div data-aos="fade-up">
            <p data-aos="fade-up">
              Hello, I&apos;m Rushikesh, an experianced DevOps Engineer with a flair for streamlining operations through the magic of automation,
              continuous integration, and deployment. Over the past 2 years, I&apos;ve honed my skills and expertise in the dynamic fields
              of DevOps and Cloud Computing. My journey has been marked by hands-on experience and a deep dive into the 
              world of cutting-edge technologies.
            </p>
            <p data-aos="fade-up">
              Fast-forward to today, and I’ve had the privilege of working at{' '}
              <a href="https://www.vwg-digitalsolutions.in/">Volkswagen Group Digital Solutions [India],</a> {' '} is a global technology hub for the Volkswagen Group.
              My mission is crystal clear - to empower organizations with swifter, more effective software delivery 
              while ensuring unwavering levels of excellence and dependability.
            </p>
            {/* <p>
              Fast-forward to today, and I’ve had the privilege of working at{' '}
              <a href="https://us.mullenlowe.com/">an advertising agency</a>,{' '}
              <a href="https://starry.com/">a start-up</a>,{' '}
              <a href="https://www.apple.com/">a huge corporation</a>, and{' '}
              <a href="https://scout.camd.northeastern.edu/">a student-led design studio</a>. My
              main focus these days is building accessible, inclusive products and digital
              experiences at <a href="https://upstatement.com/">Upstatement</a> for a variety of
              clients.
            </p> */}

            {/* <p>
              I also recently{' '}
              <a href="https://www.newline.co/courses/build-a-spotify-connected-app">
                launched a course
              </a>{' '}
              that covers everything you need to build a web app with the Spotify API using Node
              &amp; React.
            </p> */}

            <p data-aos="fade-up">Here are a few technologies I’ve been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i} data-aos="fade-up" data-aos-duration="1000">{skill}</li>)}
          </ul>
        </StyledText>
        <StyledPic data-aos="fade-up">
          <div className="wrapper">
            <StaticImage
              className="img"
              data-aos="fade-up"
              src="../../images/profile.png"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
